export const metatagilistaportali = {
  Page: {
    "meta-tagi": {
      Title:
        "Chiny.com.pl - zarezerwuj najlepsze wczasy i wycieczki z TravelOne.pl. Mapa Świata wszystkich portali z Grupy TravelOne.pl.",
      Description:
        "Ponad 58 krajów, wszystkie portale w jednym miejscu. Oferty wczasów last minute i wycieczek do Chin. Wakacje z dziećmi, hotele SPA, piękne plaże - wakacje All Inclusive w Chinach. ::: Zaplanuj idealne wakacje z Grupą Portali TravelOne.pl!",
      Keywords: []
    }
  }
};
